import React from 'react';

import Demo, { DemoSliderControl } from '@/components/Demo';
import ToggleButton from '@/components/ToggleButton';
import InlineCode from '@/components/InlineCode';

import AutoRotate from './AutoRotate';

function FoldPerspectiveDemo() {
  const [enableSpin, setEnableSpin] = React.useState(false);

  return (
    <Demo
      id="perspective"
      initialValues={{
        perspective: 500,
      }}
      controlPosition="top"
      customGrid={{
        gridTemplateColumns: 'min(450px, 100%)',
        justifyContent: 'center',
      }}
      controls={[
        <DemoSliderControl
          key="perspective"
          id="perspective"
          label="Perspective"
          min={50}
          max={2000}
        />,
      ]}
      renderAltControls={() => {
        return (
          <ToggleButton
            active={enableSpin}
            handleToggle={() => setEnableSpin(!enableSpin)}
            style={{ width: 'max-content', marginInline: 'auto' }}
          >
            Enable Rotation
          </ToggleButton>
        );
      }}
    >
      {({ perspective }) => {
        return (
          <div
            style={{
              perspective: perspective + 'px',
            }}
          >
            <div
              style={{
                paddingBottom: 32,
                textAlign: 'center',
              }}
            >
              <InlineCode
                style={{
                  position: 'relative',
                  zIndex: 2,
                  fontSize: '1.3125rem',
                  mixBlendMode: 'revert',
                }}
              >
                perspective: {Math.round(perspective)}px
              </InlineCode>
            </div>
            <AutoRotate enabled={enableSpin}>
              <img
                width="100%"
                src="/images/folding-the-dom/cats.jpg"
                alt="cats in a basket"
                style={{ maxWidth: 400 }}
              />
            </AutoRotate>
          </div>
        );
      }}
    </Demo>
  );
}

export default FoldPerspectiveDemo;
